"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationDetailsTemplateRender = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const notification_center_models_1 = require("@forto-dev/notification-center-models");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const Survey_1 = require("../../../features/Survey");
const getNotificationDetails_1 = require("../api/getNotificationDetails");
const trackingIds = {
    shadowDom: 'notification_center-notification_detail',
};
const useStyles = (0, silhouette_core_1.makeStyles)({
    root: {
        textAlign: 'left',
        display: 'flex',
    },
});
const NotificationDetailsTemplateRender = ({ notificationID, status, }) => {
    const classes = useStyles();
    const { data, isFetching, isError } = (0, getNotificationDetails_1.useNotificationDetails)({ notificationID, status });
    const notificationReference = data?.reference;
    const isSurveyEnabled = (0, Survey_1.useIsSurveyEnabled)(notificationReference);
    if (isFetching) {
        return ((0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { display: "flex", justifyContent: "center", height: "100%", children: (0, jsx_runtime_1.jsx)(silhouette_core_1.CircularProgress, {}) }));
    }
    if (!data || isError) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: classes.root, dangerouslySetInnerHTML: { __html: data.renderedContent }, "data-tracking-id": trackingIds.shadowDom }), isSurveyEnabled && notificationReference && ((0, jsx_runtime_1.jsxs)(silhouette_core_1.Box, { ml: 9, mr: 4, "data-testid": "mot-usefulness-survey-container", children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.Divider, {}), (0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { py: 0.5, children: (0, jsx_runtime_1.jsx)(Survey_1.MOTUsefulnessSurvey, { reference: notificationReference, channelType: notification_center_models_1.ChannelType.Web, correlationID: notificationID, correlationType: notification_center_models_1.CorrelationType.UserNotification }) }), (0, jsx_runtime_1.jsx)(silhouette_core_1.Divider, {})] }))] }));
};
exports.NotificationDetailsTemplateRender = NotificationDetailsTemplateRender;
//# sourceMappingURL=NotificationDetailsTemplateRender.js.map